import { useState } from "react";

const faqs = [
  {
    q: "What types of businesses do you support?",
    a: "We work with businesses of all sizes — from solo entrepreneurs and small offices to mid-sized enterprises with multiple locations. Our services are tailored to fit your specific needs and budget.",
  },
  {
    q: "How quickly can you respond to an IT emergency?",
    a: "For remote support, we typically connect within 15–30 minutes. For onsite emergencies, our engineers aim to be on-site within 2–4 hours depending on your location. We offer 24/7 remote support for critical issues.",
  },
  {
    q: "Do you offer ongoing managed IT services or just one-time fixes?",
    a: "Both! We offer one-time support for specific issues as well as fully managed IT service plans that cover monitoring, maintenance, helpdesk, and proactive security — all for a predictable monthly fee.",
  },
  {
    q: "Is my data safe when you access my systems remotely?",
    a: "Absolutely. We use enterprise-grade encrypted remote access tools and follow strict security protocols. All sessions are logged and you can revoke access at any time. Your data privacy is our top priority.",
  },
  {
    q: "What cloud platforms do you support?",
    a: "We support all major cloud platforms including Microsoft Azure, Amazon Web Services (AWS), and Google Cloud Platform. We can help with migration, management, cost optimization, and hybrid cloud setups.",
  },
  {
    q: "Do you provide cybersecurity services for small businesses?",
    a: "Yes — in fact, small businesses are often the most vulnerable targets. We offer security audits, firewall setup, endpoint protection, email security, and staff training packages designed specifically for smaller organizations.",
  },
  {
    q: "How do I get started with SilentNet?",
    a: "Simply fill out our contact form or give us a call. We'll schedule a free 30-minute consultation to understand your needs and recommend the right solution. No commitment required.",
  },
  {
    q: "Do you offer service contracts or SLAs?",
    a: "Yes. Our managed IT plans come with clearly defined Service Level Agreements (SLAs) that guarantee response times, uptime targets, and support availability. We believe in full transparency.",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <section id="faq" className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="text-teal-600 text-xs font-semibold tracking-widest uppercase mb-3 block">
            Common Questions
          </span>
          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900">
            Frequently Asked Questions
          </h2>
        </div>

        {/* Accordion */}
        <div className="flex flex-col gap-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className={`rounded-xl border transition-all duration-200 overflow-hidden ${
                open === i ? "border-teal-200 bg-teal-50/40" : "border-gray-100 bg-gray-50"
              }`}
            >
              <button
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer"
              >
                <span className="font-semibold text-gray-900 text-sm pr-4">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`text-teal-500 text-lg transition-transform duration-200 ${
                      open === i ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  />
                </div>
              </button>
              {open === i && (
                <div className="px-6 pb-5">
                  <div className="w-8 h-0.5 bg-teal-400 mb-3" />
                  <p className="text-gray-600 text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
